export const addTooltipDayOverlay = (target: HTMLElement, text: string, grid: HTMLElement): void => {
    const index = [...grid.querySelectorAll(":scope > div:is(.day, .offset)")].indexOf(target);
    if (index > -1) {
        const span = target.querySelector<HTMLSpanElement>(".day-holiday") || document.createElement("span");
        span.title = text;
        span.style.gridColumn = `${(index % 7) + 1} / span 1`;
        span.style.gridRow = `${Math.floor(index / 7) + 1} / span 1`;
        target.style.gridColumn = span.style.gridColumn;
        target.style.gridRow = span.style.gridRow;
        grid.append(span);
    }
};
